var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49ef"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49ef"] = parcelRequire;
}

var $k8sLY = parcelRequire("k8sLY");
var $ieD7c = parcelRequire("ieD7c");
const $20751ef0ad50b9fe$var$storageKey = "cookies-accepted";
function $20751ef0ad50b9fe$export$5253876270c4e383() {
    const timeout = [
        "/",
        "/index.html"
    ].includes(window.location.pathname) ? 4500 : 0;
    const hasAcceptedCookies = localStorage.getItem($20751ef0ad50b9fe$var$storageKey);
    if (hasAcceptedCookies === "true") return;
    setTimeout(()=>{
        const cookieElement = document.querySelector(".cookies");
        cookieElement.style.display = "";
        cookieElement.querySelector("button").addEventListener("click", ()=>{
            cookieElement.style.display = "none";
            localStorage.setItem($20751ef0ad50b9fe$var$storageKey, "true");
        });
    }, timeout);
}


// loading placeholder
document.addEventListener("DOMContentLoaded", function(e) {
    (0, $k8sLY.gsap).set(".page-content", {
        display: "block"
    });
    (0, $k8sLY.gsap).to(".loading-placeholder", {
        duration: 0.5,
        opacity: 0,
        delay: 0.3,
        ease: (0, $ieD7c.Power3).easeOut,
        onComplete: function() {
            (0, $k8sLY.gsap).set(".loading-placeholder", {
                pointerEvents: "none"
            });
        }
    });
    (0, $k8sLY.gsap).to(".container-content", {
        duration: 0.5,
        opacity: 1,
        delay: 6,
        ease: (0, $ieD7c.Power3).easeOut
    });
    (0, $20751ef0ad50b9fe$export$5253876270c4e383)();
});
const $1a2d790347afc103$var$navigation = document.querySelector(".navigation");
const $1a2d790347afc103$var$sandwich = document.querySelector(".navigation__sandwich");
$1a2d790347afc103$var$sandwich.addEventListener("click", ()=>{
    $1a2d790347afc103$var$navigation.classList.toggle("navigation--open");
});
const $1a2d790347afc103$var$btnOpen = document.querySelector(".btn-open");
const $1a2d790347afc103$var$btnClose = document.querySelector(".btn-close");
const $1a2d790347afc103$var$overlay = document.querySelector(".overlay");
if ($1a2d790347afc103$var$btnOpen) $1a2d790347afc103$var$btnOpen.addEventListener("click", $1a2d790347afc103$var$openOverlay);
if ($1a2d790347afc103$var$btnOpen) $1a2d790347afc103$var$btnClose.addEventListener("click", $1a2d790347afc103$var$closeOverlay);
function $1a2d790347afc103$var$openOverlay() {
    $1a2d790347afc103$var$overlay.classList.add("overlay--open");
}
function $1a2d790347afc103$var$closeOverlay() {
    $1a2d790347afc103$var$overlay.classList.remove("overlay--open");
}
const $1a2d790347afc103$var$ticker = document.querySelector(".container-content-ticker");
// if (ticker) ticker.addEventListener('click', openEditMode)
// function openEditMode() {
//     ticker.classList.toggle('container-content-ticker__list')
// }
if (window.sitecakeGlobals || sitecakeGlobals.editMode == true) $1a2d790347afc103$var$ticker.classList.add("container-content-ticker__list");


//# sourceMappingURL=index.c6fba95c.js.map
